module.exports = __webpack_public_path__ + "static/media/need-perscriptions.e655b8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/need/need-perscriptions.jpg
// module id = 370
// module chunks = 0